import { useEffect } from "react";

const DEFAULT_TITLE = "STAVBOŠ – stavební bazar a online inzerce";
const DEFAULT_DESC = "Stavební bazar a stavební inzerce: stroje, nářadí, materiál i půjčovna. Online inzerce a inzerce stavba zdarma.";
const DEFAULT_KEYWORDS = "stavební bazar, stavební inzerce, inzerce stavba, inzerce, online inzerce, bazar stavebniny, inzerce nářadí, inzerce stroje, STAVBOŠ";

function setMeta(name, content, attr = "name") {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function setJsonLd(id, json) {
  document.querySelectorAll(`script[data-seo-id="${id}"]`).forEach((s) => s.remove());
  if (!json) return;
  const s = document.createElement("script");
  s.type = "application/ld+json";
  s.dataset.seoId = id;
  s.text = JSON.stringify(json);
  document.head.appendChild(s);
}

export function useSEO({ title, description, image, canonicalPath, jsonLd } = {}) {
  useEffect(() => {
    const finalTitle = title ? `${title} – STAVBOŠ` : DEFAULT_TITLE;
    const finalDesc = description || DEFAULT_DESC;
    document.title = finalTitle;
    setMeta("description", finalDesc);
    setMeta("keywords", DEFAULT_KEYWORDS);
    setMeta("og:title", finalTitle, "property");
    setMeta("og:description", finalDesc, "property");
    if (image) {
      setMeta("og:image", image, "property");
      setMeta("twitter:image", image);
    }
    setMeta("twitter:title", finalTitle);
    setMeta("twitter:description", finalDesc);

    const origin = window.location.origin;
    const canonical = canonicalPath
      ? `${origin}${canonicalPath}`
      : `${origin}${window.location.pathname}`;
    setCanonical(canonical);
    setMeta("og:url", canonical, "property");

    setJsonLd("page", jsonLd || null);

    return () => setJsonLd("page", null);
  }, [title, description, image, canonicalPath, JSON.stringify(jsonLd)]);
}
